import baseStyled, {
  ThemedStyledInterface,
  ThemedCssFunction,
  css as baseCss,
} from 'styled-components/macro';
import type { V4Theme } from './v4-theme';

/**
 * Типизированные обёртки styled и css,
 * чтобы theme в styled-компонентах имел тип V4Theme.
 */
const styled = baseStyled as ThemedStyledInterface<V4Theme>;
export const css = baseCss as ThemedCssFunction<V4Theme>;

export default styled;
